import React, { Component, Suspense } from 'react'
import { getData, pageHitAPICall } from '../services';
import { Helmet } from "react-helmet-async";
import background from "../images/banner2.jpg";
import { printParams } from "../config";
import Globalsearch from './globalSearch';
let Banner = React.lazy(() => import("./banner"))
let Bannerdots = React.lazy(() => import("./bannerdots"))
let Category = React.lazy(() => import("./category"))
let Comments = React.lazy(() => import("./comments"))
let FullVideo = React.lazy(() => import("./fullVideo"))
let StoreProfile = React.lazy(() => import("../lokalIn/storeProfile"))
let RestaurantListingSubdomain = React.lazy(() => import("../restaurant/restaurantListingSubdomain"))
export default class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            banner: [],
            video: [],
            steps: [],
            comments: [],
            advertisment: [],
            imgdata: ''
        };
    }
    componentDidMount() {
        if (window.sessionStorage.getItem('subDomainFlag') !== "1") {
            window.scrollTo(0, 0)
            const postData = {
                "functionName": "lokal/themeList",
                "siteId": localStorage.getItem('siteId'),
                "themeId": localStorage.getItem('themeId')
            }
            getData(postData).then((data) => {
                printParams("lokal/themeList", data)
                if (data.data.success === "1") {
                    this.setState({
                        banner: data.data.Banner,
                        video: data.data.Video,
                        steps: data.data.Steps,
                        comments: data.data.Comments,
                        advertisment: data.data.Advertisement
                    });
                }
            })
            var sellerID = "";
            var moduleID = 1;
            var siteCategoryGroupId = "";
            if (window.sessionStorage.getItem('siteCategoryId') !== "0") {
                siteCategoryGroupId = window.sessionStorage.getItem('siteCategoryId');
            }
            else {
                sellerID = window.sessionStorage.getItem('sellerId');
            }
            pageHitAPICall(sellerID, moduleID, siteCategoryGroupId);
        }
    }
    render() {
        return (
            <Suspense fallback={<div></div>}>
                {(window.sessionStorage.getItem('subDomainFlag') === "1" && window.sessionStorage.getItem('mainGroupCategory') === "5") ?
                    <RestaurantListingSubdomain />
                    :
                    (window.sessionStorage.getItem('subDomainFlag') === "1") ?
                        <StoreProfile />
                        :
                        <div className="" >
                            <Helmet>
                                <link rel="canonical" href={window.location.href} />
                                <title>{window.sessionStorage.getItem("seoTitle")}</title>
                                <meta name="description" content={window.sessionStorage.getItem("seoDescription")} />
                                <meta name="keywords" content={window.sessionStorage.getItem("seoKeyword")} ></meta>
                                <meta name="twitter:title" content={window.sessionStorage.getItem("seoTitle")}></meta>
                                <meta name="twitter:description" content={window.sessionStorage.getItem("seoDescription")}></meta>
                                <meta name="twitter:image:src" content={window.sessionStorage.getItem("seoImage")}></meta>
                                <meta name="facebook:title" content={window.sessionStorage.getItem("seoTitle")}></meta>
                                <meta name="facebook:description" content={window.sessionStorage.getItem("seoDescription")}></meta>
                                <meta name="facebook:image:src" content={window.sessionStorage.getItem("seoImage")}></meta>
                                <meta property='og:type' content='website' />
                                <meta property="og:title" content={window.sessionStorage.getItem("seoTitle")} ></meta>
                                <meta property="og:image" content={window.sessionStorage.getItem("seoImage")} ></meta>
                                <meta property="og:description" content={window.sessionStorage.getItem("seoDescription")} ></meta>
                                <meta property='og:site_name' content={window.sessionStorage.getItem("siteName")} />
                                <meta property="og:url" content={window.sessionStorage.getItem("seoUrl")} ></meta>
                            </Helmet>
                            {/* <div className="contentWrap" id="divIdToPrint"> */}
                            <div className={(localStorage.getItem('hasGlobalSearch') == "false") ? "contentWrap 111" : "contentWrap dentalcontentWrap 222" } id="divIdToPrint">
                                <Banner bannerData={this.state.banner} />
                                {/* {localStorage.getItem('hasGlobalSearch') === true }
                                <Globalsearch />  data.data.Banner*/}
                                {(localStorage.getItem('hasGlobalSearch') == "false") ?
                                <div className="categorySection" style={{ backgroundImage: localStorage.getItem('themeId') === '29' ? `url(${background})` : "", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}   >
                                    <div className="container">
                                        {localStorage.getItem('themeId') === '29' ?
                                            <div className="titleHeading whiteText gsa-title-haeding" >
                                                <h2>Buy Best & Feel Best at  <span style={{ color: "#C3161C", fontStyle: 'normal' }}>{window.sessionStorage.getItem("groupName")}</span> </h2>
                                                <p class="col-md-6 mx-auto">Feel the joy of mouthwatering food.</p>
                                                <p class="text-center"><b>Categories:</b></p>
                                            </div>
                                            :
                                            window.sessionStorage.getItem('siteCategoryId') === "5" ?

                                                <div className="titleHeading whiteText gsa-title-haeding">
                                                    {/* <h2>Go Lokal!</h2> */}
                                                    <p class="col-md-6 mx-auto">Your one-stop shop for all your daily needs
                                                        from local dental stores.</p>
                                                    <p class="text-center"><b>Categories:</b></p>
                                                </div>
                                                :
                                                <div className="titleHeading whiteText gsa-title-haeding">
                                                    {window.sessionStorage.getItem('siteCategoryId') === "7" ? "" : <h2>Go Lokal!</h2>}
                                                    <p class="col-md-6 mx-auto">Your one-stop shop for all your daily needs
                                                        from local {window.sessionStorage.getItem('siteCategoryId') === "7" ? "pets" : "grocery"} stores.</p>
                                                    <p class="text-center"><b>Categories:</b></p>
                                                </div>
                                        }
                                        <Category fromPage={'lokalHome'} />
                                    </div>
                                </div>:
                                ""
                                 }
                                <FullVideo videoData={this.state.video}></FullVideo>
                                <Bannerdots imageData={this.state.steps}></Bannerdots>
                                <Comments commentsData={this.state.comments} />
                            </div>
                        </div>
                }
            </Suspense>
        )
    }
}